import { useMutation, useQueryClient } from 'react-query'
import axios from 'lib/axiosConfig'
import { AddToRouteMutation, CreateNewRouteMutation } from 'types/api/delivery'

export const useMutateNewDeliveryRoute = (placeId: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    (shipmentData: CreateNewRouteMutation) =>
      axios.post(`/v1/dts/places/${placeId}/deliveries`, shipmentData),
    {
      onMutate: async () => {
        queryClient.cancelQueries(['deliveries', 'ordersForPlace'])
      },
      onSuccess: () => {
        queryClient.refetchQueries(['deliveries'])
        queryClient.refetchQueries(['ordersForPlace'])
      },
    }
  )
}

export const useMutateUpdateDeliveryShipments = (placeId: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    (shipmentData: AddToRouteMutation) =>
      axios.put(`/v1/dts/places/${placeId}/deliveries`, shipmentData),
    {
      onMutate: async () => {
        queryClient.cancelQueries(['deliveries'])
      },
    }
  )
}
